import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState, } from 'react';
import CodeInput from '../input/CodeInput';
import { Container, InputWrapper } from './styles';
export const TWO_FA_INPUTS_COUNT = 6;
const getDefaultCodeState = (length) => Array.from({ length }, () => '');
const CodeInputs = ({ length = TWO_FA_INPUTS_COUNT, type, disabled, onComplete, onCodeDelete, }) => {
    const [code, setCode] = useState(getDefaultCodeState(length));
    const inputs = useRef([]);
    const oldAuthType = useRef(type);
    const processInput = (e, slot) => {
        const num = e.target.value;
        if (/[^0-9]/.test(num))
            return;
        if (code[slot] && num) {
            let filteredTarget = e.target.value;
            if (filteredTarget.charAt(0) !== filteredTarget.charAt(1)) {
                filteredTarget = filteredTarget.replace(code[slot], '');
            }
            else {
                filteredTarget = filteredTarget.charAt(0);
            }
            setCode(code.map((codeNum, index) => index === slot ? filteredTarget : codeNum));
            if (inputs.current[slot + 1])
                inputs.current[slot + 1].focus();
            return;
        }
        if (num.length > 1) {
            const newCode = code.map((codeNum, i) => {
                if (i < slot)
                    return codeNum;
                if (num[i - slot]) {
                    if (i < code.length - 1) {
                        inputs.current[i + 1].focus();
                    }
                    return num[i - slot];
                }
                return '';
            });
            setCode(newCode);
            if (newCode.every((num) => num !== '')) {
                onComplete(newCode.join(''));
            }
            return;
        }
        const newCode = [...code];
        newCode[slot] = num;
        setCode(newCode);
        // check if next input is available
        if (slot !== length - 1 && num !== '') {
            inputs.current[slot + 1]?.focus();
        }
        // if every input has a value
        if (newCode.every((num) => num !== '')) {
            onComplete(newCode.join(''));
        }
    };
    const onKeyUp = (e, slot) => {
        if (e.key === 'Backspace' && slot !== 0) {
            const newCode = [...code];
            let slotToChange;
            if (newCode[slot] === '') {
                if (newCode[slot + 1]) {
                    slotToChange = slot;
                }
                else {
                    slotToChange = slot - 1;
                }
            }
            else {
                slotToChange = slot;
            }
            inputs.current[slotToChange]?.focus();
            if (typeof onCodeDelete === 'function') {
                onCodeDelete(newCode.join(''));
            }
            setCode(newCode);
        }
    };
    const handleRef = (ref) => {
        if (inputs.current.length >= length)
            return;
        inputs.current.push(ref);
    };
    useEffect(() => {
        if (type !== oldAuthType.current) {
            setCode(getDefaultCodeState(length));
            inputs.current[0]?.focus();
            oldAuthType.current = type;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [type]);
    return (_jsx(Container, { children: code.map((num, idx) => {
            const handleInputProcess = (e) => processInput(e, idx);
            const handleKeyUp = (e) => onKeyUp(e, idx);
            return (_jsx(InputWrapper, { amount: length, children: _jsx(CodeInput, { type: "text", value: num, 
                    // maxLength={1}
                    inputMode: "numeric", readOnly: disabled, testId: `code-input-${idx}`, 
                    // autoFocus={!code[0]?.length && idx === 0} // disabling autofocus because sometimes the content does not recognize the keyboard on mobile
                    ref: handleRef, onKeyUp: handleKeyUp, onChange: handleInputProcess }) }, idx));
        }) }));
};
export default CodeInputs;
//# sourceMappingURL=CodeInputs.js.map